<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="formData" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="发票编码" prop="invoiceId">
              {{ formData.invoiceId }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商名称" prop="userId" placeholder="请选择供应商名称">
              {{ formData.userName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抬头名称" prop="headerId" placeholder="请选择抬头名称">
              {{ formData.headerName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票金额" prop="invoiceAmount">
              {{ formData.invoiceAmount }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票类型" prop="invoiceType">
              {{ invoiceTypeMap.get(formData.invoiceType) }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票状态" prop="invoiceStatus">
              {{ invoiceStatusMap.get(formData.invoiceStatus) }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间" prop="createTime">
              {{ formData.ctime }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="关联提货订单" prop="objIdList">
              <el-table key="TH" v-if="formData.sourceType === 'TH'" :data="formData.objList">
                <el-table-column prop="pickupNumber" label="提货编号"></el-table-column>
                <el-table-column prop="orderNumber" label="订单编号"></el-table-column>
                <el-table-column prop="totalAmount" label="提货总金额"></el-table-column>
                <!-- <el-table-column prop="releasedDepositAmount" label="释放保证金总额"></el-table-column> -->
                <el-table-column prop="isDepositAmount" label="保证金抵扣货款">
                  <template v-slot="{ row }">
                    {{ row.isDepositAmount ? '是' : '否' }}
                  </template>
                </el-table-column>
                <el-table-column prop="depositNum" label="总提货数量">
                  <template v-slot="{ row }">
                    <div v-if="row.pickupId" style="display: flex;justify-content: center;align-items: center;">
                      <el-button type="text" @click="loadGgList(row.pickupId)">{{ row.depositNum || '--' }}</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-table key="CY" v-if="formData.sourceType === 'CY'" :data="formData.objList">
                <el-table-column show-overflow-tooltip min-width="120" label="费用发生日期" prop="pickupNumber"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" label="数量(吨)" prop="depositNum"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="130" label="总价(元)" prop="totalAmount"></el-table-column>
                <el-table-column label="操作" prop="totalAmount">
                  <template v-slot="{ row }">
                    <el-button type="text" @click="$router.push({ path: '/oilTankCost/detail', query: { id: row.pickupId } })">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="invoiceRemark">
              {{ formData.invoiceRemark }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload readonly v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="发票" prop="invoiceList">
              <file-upload readonly v-model="formData.invoiceList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button v-if="formData.invoiceStatus === '1'" type="primary" @click="showInvoice"
            class="global-button">上传发票</el-button>
          <el-button v-if="formData.invoiceStatus === '4'" type="primary" @click="showInvoiceZf = true"
            class="global-button">作废审批</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-dialog class="global-dialog" :append-to-body="true" :visible.sync="showInvoiceVisible" title="上传发票附件"
      width="500">
      <el-form class="global-form" :model="formData2" :rules="rules2" ref="formData2"
        style="padding: 30px 40px 20px 20px;">
        <el-form-item label="发票附件" prop="invoiceList">
          <file-upload v-model="formData2.invoiceList" :multiple="true" :limit="10"></file-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="showInvoiceVisible = false">取消</el-button>
          <el-button type="primary" @click="submit">确定</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog class="global-dialog" :append-to-body="true" :visible.sync="showInvoiceZf" title="作废申请" width="500">
      <el-form class="global-form" :model="formData3" :rules="rules3" ref="formData3"
        style="padding: 30px 40px 20px 20px;">
        <el-form-item label="发票附件" prop="invoiceStatus">
          <el-radio-group v-model="formData3.invoiceStatus">
            <el-radio label="3">通过</el-radio>
            <el-radio label="2">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="showInvoiceZf = false">取消</el-button>
          <el-button type="primary" @click="zfSubmit">确定</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="入场规格清单" :visible.sync="guigeVisible" width="800px">
      <el-table size="mini" stripe border :data="planGgList">
        <el-table-column min-width="180" label="规格名称" prop="specName"></el-table-column>
        <el-table-column min-width="120" label="规格单位" prop="unit"></el-table-column>
        <el-table-column min-width="120" label="计划数量" prop="planQuantity"></el-table-column>
        <el-table-column min-width="120" label="实际数量" prop="pickupQuantity"></el-table-column>
        <el-table-column min-width="120" label="单价" prop="specPrice"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { invoiceType, invoiceStatus, costTypeList } from '@/utils/dict'
import { deepClone } from '@/utils/utils'
export default {
  name: 'InvoiceManageDetail2',
  data() {
    return {
      planGgList: [],
      guigeVisible: false,
      showInvoiceVisible: false,
      showInvoiceZf: false,
      invoiceStatusMap: invoiceStatus,
      costTypeListMap: costTypeList,
      userList: [],
      headerList: [],
      orderList: [],
      invoiceTypeMap: invoiceType,
      formData: {
        invoiceId: '', // 发票编码
        userId: '', // 关联客户id
        headerId: '', // 抬头ID
        invoiceAmount: '', // 发票金额
        invoiceStatus: '',
        invoiceType: '', // 发票类型1增值税专用发票2普通发票
        fileList: [], // 附件列表
        objIdList: [], // 关联对象id列表
        invoiceRemark: ''
      },
      formData2: {
        invoiceId: '', // 发票ID
        invoiceList: [] // 发票列表
      },
      formData3: {
        invoiceStatus: '' // 发票状态
      },
      rules: {
        invoiceId: [{ required: true, message: '请选择发票', trigger: ['change', 'blur'] }],
        invoiceList: [{ required: true, type: 'array', message: '请上传发票', trigger: ['change', 'blur'] }]
      },
      rules2: {
        invoiceList: [{ required: true, type: 'array', message: '请上传发票', trigger: ['change', 'blur'] }]
      },
      rules3: {
        invoiceStatus: [{ required: true, message: '请选择', trigger: ['change', 'blur'] }]
      }
    }
  },
  computed: {
    invoiceId() {
      return this.$route.query.invoiceId
    }
  },
  created() {
    if (this.invoiceId) {
      this.loadDetails()
    }
  },
  methods: {
    loadGgList(planId) {
      this.$axios.get(this.$apis.clyy.selectWlVehiclePlanGg1, {
        planId
      }).then(res => {
        this.planGgList = res || []
        this.guigeVisible = true
      })
    },
    invoiceStatusChange() {
      this.formData.invoiceStatus = this.formData3.invoiceStatus
    },
    orderChange() {
      this.formData.invoiceAmount = this.orderList.filter(item => this.formData.objIdList.includes(item.pickupId)).reduce((acc, cur) => parseFloat(acc) + parseFloat(cur.totalAmount), 0)
    },
    showInvoice() {
      this.showInvoiceVisible = true
      this.formData2.invoiceId = this.invoiceId
    },
    loadDetails() {
      this.$axios.get(this.$apis.lyInvoice.selectLyInvoiceByInvoiceId, {
        params: { invoiceId: this.invoiceId }
      }).then(res => {
        res.objIdList = res.objList.map(item => item.pickupId)
        this.formData = res
        console.log('res', res)
      })
    },
    zfSubmit() {
      this.$refs.formData3.validate().then(() => {
        const formData = deepClone(this.formData)
        formData.invoiceStatus = this.formData3.invoiceStatus
        const url = this.$apis.lyInvoice.updateLyInvoice
        this.$axios.post(url, formData).then(res => {
          // this.$store.dispatch('getUserList')
          this.$router.back()
        })
      })
    },
    submit() {
      this.$refs.formData2.validate().then(() => {
        const url = this.$apis.lyInvoice.updateLyInvoiceFile
        this.$axios.post(url, this.formData2).then(res => {
          // this.$store.dispatch('getUserList')
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader {
  width: 95%;
}

.flex-end {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.table-form {

  .el-select,
  .el-input,
  .el-cascader,
  .el-input-number {
    width: 100% !important;
  }

  ::v-deep .el-form-item__label {
    display: none;

    &::before {
      display: none;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
</style>
